const pageIndex = 1;
const pageSize = 2147483647;

export { pageIndex, pageSize };
